import { render, staticRenderFns } from "./DoorDescription.vue?vue&type=template&id=08fc7fa7&scoped=true"
import script from "./DoorDescription.vue?vue&type=script&lang=ts"
export * from "./DoorDescription.vue?vue&type=script&lang=ts"
import style0 from "./DoorDescription.vue?vue&type=style&index=0&id=08fc7fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc7fa7",
  null
  
)

export default component.exports